module.exports = __webpack_public_path__ + "img/Like - Fill.d44de549.svg";